import MinimaLogo from '../../assets/logos/MinimaLogo.svg';
import IntegritasLogo from '../../assets/logos/IntegritasLogoGradient.svg';
import * as Icon from '../../assets/icons/index';
import { Link } from 'react-router-dom';
import { INTEGRITAS_BASE_URL, INTEGRITAS_DOCS_WEBAPP_GUIDE_URL } from '../../config/constants';

const Footer = () => {
  return (
    <div
      className="h-auto w-full px-4 md:px-[60px] py-10 md:py-20 flex-col justify-start items-center gap-[50px] md:gap-[100px] inline-flex
         text-sm text-core-grey-150"
    >
      <div className="self-stretch flex flex-col md:flex-row justify-start items-start gap-8 md:gap-[389px]">
        <div className="flex-col justify-start items-start gap-4 inline-flex">
          <img src={IntegritasLogo} />
          <div className="text-[#e9e9eb]">Verifying and stamping data on the Minima blockchain</div>
          <p className="w-[250.69px] text-justify">All rights reserved Integritas ©2025</p>
          <p className="text-justify">
            <a
              href={`${INTEGRITAS_BASE_URL}/privacy-policy`}
              target="_blank"
              rel="noopener noreferrer"
              className="hover:text-white"
            >
              Privacy Policy
            </a>
            {' | '}
            <a
              href={`${INTEGRITAS_BASE_URL}/terms`}
              target="_blank"
              rel="noopener noreferrer"
              className="hover:text-white"
            >
              Terms and conditions
            </a>
          </p>
        </div>
        <div className="flex flex-col justify-center items-start gap-4 whitespace-nowrap">
          <Link to="/stamp" className="hover:text-white">
            Stamp
          </Link>
          <Link to="/analyze" className="hover:text-white">
            Analyze
          </Link>
          <Link to="/stamps" className="hover:text-white">
            My Stamps
          </Link>
          <Link to="/verifications" className="hover:text-white">
            My Verifications
          </Link>
          <Link to="/about" className="hover:text-white">
            About
          </Link>
          <a
            href={`${INTEGRITAS_DOCS_WEBAPP_GUIDE_URL}`}
            target="_blank"
            rel="noopener noreferrer"
            className="hover:text-white"
          >
            Documentation
          </a>
          <Link to="/report-issue" className="hover:text-white">
            Report issue
          </Link>
        </div>
      </div>
      <div className="self-stretch flex flex-col md:flex-row justify-between items-start md:items-end gap-4 md:gap-0">
        <div className="h-[32px] justify-start items-end gap-8 flex">
          <img src={MinimaLogo} className="h-full" />
          <p className="text-justify">Powered by Minima</p>
        </div>
        <div className="hidden md:flex h-full items-center gap-2 footer-icon">
          <a href="https://discord.com/invite/minimaglobal">
            <Icon.Discord />
          </a>
          <a href="https://www.linkedin.com/company/minimaglobal/">
            <Icon.LinkedIn />
          </a>
          <a href="https://t.me/Minima_Global">
            <Icon.Telegram />
          </a>
          <a href="https://github.com/minima-global">
            <Icon.GitHub />
          </a>
          <a href="https://x.com/Minima_Global?s=20">
            <Icon.XTwitter />
          </a>
          <a href="https://www.youtube.com/channel/UCDe2j57uQrUVtVizFbDpsoQ">
            <Icon.Youtube />
          </a>
          <a href="https://minimaglobal.substack.com/">
            <Icon.SubStack />
          </a>
          <a href="https://coinmarketcap.com/currencies/minima-global/">
            <Icon.CoinMarketCap />
          </a>
          <a href="https://www.coingecko.com/en/coins/minima">
            <Icon.CoinGecko />
          </a>
        </div>
      </div>
    </div>
  );
};
export default Footer;
